import { InfotextDisplayModel } from "@/api/model-index";
import { DocumenttypeDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/documenttype-display-model";
import { AnfrageService } from "@/api/service-index";
import { PortalContextService } from "@/core/services/portal-context.service";
import { StammdatenService } from "@/core/services/stammdaten.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { of } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class GetAenderungsantragDocumenttypesResolver  {
    constructor(protected anfrageService: AnfrageService, protected portalContextService: PortalContextService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService, protected stammdatenService: StammdatenService) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<DocumenttypeDisplayModel[] | null | undefined> {
        let id: string = <string>route.params['id'];
        let sectionId: string = <string>route.params['abschnittid'];

        if (this.portalContextService.CurrentGutachten) {
            id = this.portalContextService.CurrentAnfrage.id;
        }

        await this.unfinishedHttpMethodsService.waitByUrl(state.url);

        return this.anfrageService.apiAnfrageAnfrageIdDocumenttypesGet({ anfrageId: id, aenderungsantragId: sectionId }).pipe(map(response => {
            if (response) {
                this.portalContextService.CurrentAnfrage.documenttypes = response;

                this.addDocumentTypeInfotext(response);

                return this.portalContextService.CurrentAnfrage.documenttypes;
            }

            return undefined;
        })).toPromise();
    }


    addDocumentTypeInfotext(documentTypes: DocumenttypeDisplayModel[]) {
        documentTypes.filter(documentType => documentType.infotext?.find(infotext => infotext.text && infotext.text.length > 0)).forEach(documentType => {
            let infotext = new InfotextDisplayModel();
            infotext.schluessel = 'attachments' + documentType.documenttypeId;
            infotext.beschreibung = documentType.infotext;
            infotext.name = documentType.name;
            this.stammdatenService.InfoTexte?.setValue(infotext.schluessel, infotext);
        })
    }
}